"use client";

import { createContext, useContext, useMemo } from "react";

import { useOpenWithFocus } from "./use-open-with-focus";

type MenuContextValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const MenuContext = createContext<MenuContextValue | null>(null);

export function MenuProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useOpenWithFocus(false);
  const value = useMemo(() => ({ open, setOpen }), [open, setOpen]);
  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
}

export function useMenuDrawer() {
  const ctx = useContext(MenuContext);
  if (!ctx) throw new Error("useMenuDrawer must be used inside MenuProvider");
  return ctx;
}
